import { render, staticRenderFns } from "./PartnerRegisterCopyDetail.vue?vue&type=template&id=e4b46ef6&scoped=true&"
import script from "./PartnerRegisterCopyDetail.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterCopyDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b46ef6",
  null
  
)

export default component.exports